import { Skeleton } from '@material-ui/lab';
import classNames from 'clsx';
import React from 'react';

import styles from './StandingsSkeleton.scss';

const StandingsSkeleton = () => (
  <>
    <div className={styles.tagSection}>
      <Skeleton className={styles.standingsSkeleton} variant="text" height={30} width={170} />
    </div>
    <Skeleton
      className={classNames(styles.standingsSkeleton, styles.titleSkeleton)}
      variant="text"
      height={40}
      width="50%"
    />
    <Skeleton
      className={classNames(styles.standingsSkeleton, styles.textSkeleton)}
      variant="text"
      height={30}
      width="50%"
    />
    <Skeleton
      className={classNames(styles.standingsSkeleton, styles.tableSkeleton)}
      variant="rect"
      height={200}
      width="100%"
    />
  </>
);

export default StandingsSkeleton;
